/*******************************************************************************
 * Dependency Imports
 ******************************************************************************/

// Helpers
import { getEndpoint } from '@lib/helpers'
import axios from 'axios'

/*******************************************************************************
 * Private methods
 ******************************************************************************/

/*******************************************************************************
 * Public methods
 ******************************************************************************/

/**
 * get the auctioneer's sale codes
 * @returns 
 */
export const getSaleCodes = async (auctioneer_id, params = []) => {

    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        axios({
            method: 'get',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/sale-codes', params),
            headers: {
                'Accept': 'application/json'
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get the auctioneer's sale codes
 * @returns
 */
export const getSaleSections = async (auctioneer_id, params = []) => {

    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        axios({
            method: 'get',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/sale-sections', params),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * get the auctioneer
 * @returns 
 */
export const show = async auctioneer_id => {

    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        axios({
            method: 'get',
            url: getEndpoint('/auctioneer/'+auctioneer_id),
            headers: {
                'Accept': 'application/json'
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

/**
 * get the auctioneer
 * @returns
 */
export const publicShow = async auctioneer_id => {

    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        axios({
            method: 'get',
            url: getEndpoint('/public/auctioneer/'+auctioneer_id),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const getBiddingIntervalRules = async (auctioneer_id, params) => {
    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        axios({
            method: 'get',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/rules', params),
            headers: {
                'Accept': 'application/json'
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

export const deleteRule = async (auctioneer_id, rule_id) => {
    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        if (!rule_id) {
            reject({message: 'rule_id missing'})
            return
        }

        axios({
            method: 'delete',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/rules/'+rule_id),
            headers: {
                'Accept': 'application/json'
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

export const createRule = async (auctioneer_id, payload) => {
    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        if (!payload) {
            reject({message: 'payload missing'})
            return
        }

        axios({
            method: 'post',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/rules'),
            data: payload,
            headers: {
                'Accept': 'application/json'
            }
        })
        .then(( response ) => {
            resolve( response )
        })
        .catch(( error ) => {
            reject( error )
        })
    })
}

export const getConfigurations = async auctioneer_id => {
    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        axios({
            method: 'get',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/configurations'),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const getSuggestedAccountCode = async auctioneer_id => {
    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        axios({
            method: 'get',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/suggest-account-code'),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const users = async (auctioneer_id, params = []) => {

    const url = getEndpoint('/auctioneer/' + auctioneer_id + '/users', params)

    return new Promise(( resolve, reject ) => {
        axios({
            method: 'get',
            url,
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * get the locations associated to a specific auctioneer
 * @param auctioneer_id
 * @returns {Promise<unknown>}
 */
export const locations = async auctioneer_id => {

    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        axios({
            method: 'get',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/locations'),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

// export const getAccountLocations = async (auctioneer_id, account_id) => {
//
//     return new Promise(( resolve, reject ) => {
//
//         if (!auctioneer_id) {
//             reject({message: 'auctioneer_id missing'})
//             return
//         }
//
//         if (!account_id) {
//             reject({message: 'account_id missing'})
//             return
//         }
//
//         axios({
//             method: 'get',
//             url: getEndpoint('/auctioneer/'+auctioneer_id+'/account/'+account_id+'/locations'),
//             headers: {
//                 'Accept': 'application/json'
//             }
//         })
//             .then(( response ) => {
//                 resolve( response )
//             })
//             .catch(( error ) => {
//                 reject( error )
//             })
//     })
// }

/**
 * get the locations associated to a specific auctioneer
 * @param auctioneer_id
 * @returns {Promise<unknown>}
 */
export const createLocation = async (auctioneer_id, data) => {

    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        axios({
            method: 'post',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/locations'),
            data,
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * get the locations associated to a specific auctioneer
 * @param auctioneer_id
 * @returns {Promise<unknown>}
 */
export const updateLocation = async (auctioneer_id, location_id, data) => {

    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        if (!location_id) {
            reject({message: 'location_id missing'})
            return
        }

        axios({
            method: 'patch',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/locations/'+location_id),
            data,
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const assignLocation = async (auctioneer_id, location_id) => {

    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        if (!location_id) {
            reject({message: 'location_id missing'})
            return
        }

        axios({
            method: 'post',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/locations/'+location_id+'/assign'),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const upsertConfiguration = async (auctioneer_id, payload) => {
    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        if (!payload) {
            reject({message: 'payload missing'})
            return
        }

        axios({
            method: 'post',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/configurations'),
            data: payload,
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const getConnections = async auctioneer_id => {
    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        axios({
            method: 'get',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/connections'),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * get the locations associated to a specific auctioneer
 * @param auctioneer_id
 * @param data
 * @returns {Promise<unknown>}
 */
export const update = async (auctioneer_id, data) => {

    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        axios({
            method: 'patch',
            url: getEndpoint('/auctioneer/'+auctioneer_id),
            data,
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}


export const getAssociatedOrganisations = async (auctioneer_id, params) => {

    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        axios({
            method: 'get',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/organisations', params),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const getAccount = async (auctioneer_id, account_id) => {

    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        if (!account_id) {
            reject({message: 'account_id missing'})
            return
        }

        axios({
            method: 'get',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/account/'+account_id),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const getAccountConfigurations = async (auctioneer_id, account_id) => {

    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        if (!account_id) {
            reject({message: 'account_id missing'})
            return
        }

        axios({
            method: 'get',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/account/'+account_id+'/configurations'),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const upsertAccountConfigurations = async (auctioneer_id, account_id, data) => {

    return new Promise(( resolve, reject ) => {

        if (!auctioneer_id) {
            reject({message: 'auctioneer_id missing'})
            return
        }

        if (!account_id) {
            reject({message: 'account_id missing'})
            return
        }

        axios({
            method: 'post',
            url: getEndpoint('/auctioneer/'+auctioneer_id+'/account/'+account_id+'/configurations'),
            data,
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}
